import { useId, type ComponentPropsWithRef, type ReactNode } from "react";
import { cn } from "./cn";
import { controlClasses, describedBy, FieldShell } from "./Field";

export interface TextareaProps extends ComponentPropsWithRef<"textarea"> {
  label?: ReactNode;
  hint?: ReactNode;
  error?: ReactNode;
  containerClassName?: string;
}

export function Textarea({
  label,
  hint,
  error,
  containerClassName,
  className,
  id,
  required,
  rows = 3,
  ...rest
}: TextareaProps) {
  const autoId = useId();
  const fieldId = id ?? autoId;

  return (
    <FieldShell
      id={fieldId}
      label={label}
      hint={hint}
      error={error}
      required={required}
      className={containerClassName}
    >
      <textarea
        id={fieldId}
        rows={rows}
        required={required}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy(fieldId, !!error, !!hint)}
        className={cn(controlClasses(!!error, "md"), "h-auto min-h-20 py-2 leading-relaxed", className)}
        {...rest}
      />
    </FieldShell>
  );
}
